export default {

    apiAdminAddApplicationPayoutInfo(data) {
        return this.request(this.api().ADMIN_ADD_APPLICATION_PAYOUT_INFO, data).exec().log().get();
    },

    apiExportApplicationPayout(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_APPLICATION_PAYOUT, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },

    apiGetApplicationPayoutInfo(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_APPLICATION_PAYOUT_INFO, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetConnectorPayoutMetricsInfo(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_CONNECTOR_PAYOUT_METRICS_INFO, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetPayoutStatusBreakdown(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_PAYOUT_STATUS_BREAKDOWN, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiAdminUpdateApplicationPayoutInfo(data, urldata = {}) {
        return this.request(this.api().ADMIN_UPDATE_APPLICATION_PAYOUT_INFO, data)
            .urltransform(urldata).exec().log().get();
    },

    apiAddPayoutRate(data) {
        return this.request(this.api().ADD_PAYOUT_RATE, data).exec().log().get();
    },

    apiAddPayoutRateToMonths(urldata = {}, data) {
        return this.request(this.api().ADD_PAYOUT_RATE_TO_MONTH, data)
            .urltransform(urldata)
            .exec().log().get();
    },

    apiGetPayoutRates(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_ALL_PAYOUTS, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGetPayoutRateById(urldata = {}) {
        urldata = { ...mixins.params(), ...urldata };
        return this.request(this.api().GET_PAYOUT_RATE_BY_ID,)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((res) => {
                return res
            })
            .get();
    },

    apiGetPreviousYearPayoutRates(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_PREVIOUS_YEAR_PAYOUTS, payload)
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },

    apiGeneratePayoutPdf(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GENERATE_PAYOUT_PDF, payload)
            .responsetype("arraybuffer")
            .exec().log()
            .mapresults((response) => {
                return response
            })
            .get();
    },
}